import React from 'react';
import styled from 'styled-components';

const Tag = styled.div`
  align-items: center;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  width: ${({ small }) => (small ? 80 : 120)}px;
  height: ${({ small }) => (small ? 100 : 160)}px;
  background-color: #ed1b2e;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  position: absolute;
  top: 0px;
  -webkit-transition: 0.3s all ease-in-out;
  transition: 0.3s all ease-in-out;
  z-index: 500;

  &:hover {
    background-color: #9a0b0b;
  }

  img {
    width: ${({ small }) => (small ? 50 : 80)}px;
  }
`;

const TagLogo: React.FC<{ style?: React.CSSProperties; small?: boolean }> = ({
  style,
  small = false
}) => {
  return (
    <Tag style={style} small={small}>
      <a href="https://carolinas.aaa.com/">
        <img src="https://aaacdndev.blob.core.windows.net/wordpress/icons/aaa-logo-white%402x.png" />
      </a>
    </Tag>
  );
};

export default TagLogo;
